<template>
    <div class="global-modal" :class="{'global-modal--overmenu': overMenu, 'global-modal--fullscreen': fullscreen, 'global-modal--gray': bgColorGray}">
        <div class="global-modal__content">
            <div class="global-modal__header" v-if="hasHeader()">
                <global-button icon="close"
                               theme="secondary"
                               class="modal--close ignore-context button button--icon"
                               @click="$emit('close')"/>
                <slot name="header"/>
            </div>
            <div v-if="!$slots.header" class="global-modal__no-header">
                <global-button icon="close"
                               :theme="fullscreen ? 'primary': 'ghost'"
                               class="modal--close ignore-context button button--icon"
                               :class="{'button--opacity': fullscreen}"
                               @click="$emit('close')"/>
            </div>
            <div class="global-modal__body">
                <slot name="body"/>
            </div>
            <div class="global-modal__pagination" v-if="hasPagination()">
                <slot name="pagination"/>
            </div>
            <template v-if="hasControls()">
                <div class="global-modal__devider"></div>
                <div class="global-modal__controls">
                    <div class="controls__left">
                        <slot name="controls__left"/>
                    </div>
                    <div class="controls__center">
                        <slot name="controls__center"/>
                        <slot name="controls"/>
                    </div>
                    <div class="controls__right">
                        <slot name="controls__right"/>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import GlobalButton from "../global-button/global-button";

export default {
    name: "global-modal",
    components: {GlobalButton},
    props: {
        fullscreen: {
            type: Boolean,
            default: false
        },
        overMenu: {
            // By default the modal is behind the menu layer. If this is set to true, the modal will be above the menu layer.
            type: Boolean,
            default: false
        },
        lockScrolling: {
            type: Boolean,
            default: false
        },
        bgColorGray: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        hasHeader() {
            return !!this.$slots.header || !!this.$scopedSlots.header
        },
        hasPagination() {
            return !!this.$slots.pagination
        },
        hasControls() {
            return !!this.$slots.controls__left || !!this.$slots.controls__center || !!this.$slots.controls__right
                || !!this.$scopedSlots.controls__left || !!this.$scopedSlots.controls__center || !!this.$scopedSlots.controls__right
        }
    },
    watch: {
        lockScrolling(newValue) {
            if (newValue === true) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }
        }
    },
    mounted() {
        if (this.lockScrolling) {
            document.body.classList.add('no-scroll');
        }
    },
    beforeDestroy() {
        document.body.classList.remove('no-scroll');
    }
}
</script>
